import { Box } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { useFomoState, checkQuizCouponActive } from "@/hooks/useFomoState";
import { FOMO_EXCLUDED_ROUTES } from "./FomoBanner";
import { FomoCountdownInlineBanner } from "./FomoCountdownInlineBanner";
import { FomoReassuranceInlineBanner } from "./FomoReassuranceInlineBanner";

export const FomoInlineBanner = () => {
  const { status, remainingMs } = useFomoState();
  const router = useRouter();

  if (FOMO_EXCLUDED_ROUTES.some((r) => router.route.includes(r))) return null;

  if (checkQuizCouponActive()) {
    return (
      <Box pt="12px">
        <FomoReassuranceInlineBanner variant="quiz_coupon" />
      </Box>
    );
  }

  if (status === "countdown") {
    return (
      <Box pt="12px">
        <FomoCountdownInlineBanner remainingMs={remainingMs} />
      </Box>
    );
  }

  if (status === "reassurance") {
    return (
      <Box pt="12px">
        <FomoReassuranceInlineBanner />
      </Box>
    );
  }

  return null;
};
